import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useGoBack from '@hooks/useGoBack';
import ArrowLineLeft from '@icons/arrow/ArrowLineLeft';
import { IconProps } from '@models/icons';
import { pressActionEffect } from '@styles/mixin';
import { JSX, ReactNode } from 'react';

interface Props {
    title: string;
    backIcon?: (props: IconProps) => JSX.Element;
    trailing?: ReactNode;
    onBackClick?: () => void;
    noBackIcon?: boolean;
    backgroundColor?: string;
}

function Header(props: Props) {
    const {
        title, backIcon, trailing, onBackClick, noBackIcon, backgroundColor,
    } = props;
    const goBack = useGoBack();
    const BackIcon = backIcon || ArrowLineLeft;
    return (<Wrapper backgroundColor={backgroundColor} >
        <Container>
            {noBackIcon ? (
                <span/>
            ) : (<BackIcon size={24}
                cursor='pointer'
                css={pressActionEffect}
                onClick={onBackClick ?? goBack}/>)}
            <Blank/>
            <Text fontWeight='medium'
                size='title'
                css={textCss}>
                {title}
            </Text>
            {trailing}
        </Container>
    </Wrapper>);
}

const Wrapper = styled.header<{
    backgroundColor?:string;
}>`
    background-color: ${({ backgroundColor }) => backgroundColor || 'var(--color-white)'};
    height: calc(56px + var(--safe-area-top));
    left: 0;
    padding: calc(var(--spacing-4) + var(--safe-area-top)) var(--spacing-5) var(--spacing-4);
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 10;  
`;

const Container = styled.nav`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
`;

const Blank = styled.div`
    flex:1;
`;

const textCss = css`
    position: absolute;
    transition: color 150ms;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100vw - 80px);
`;

export default Header;
